// extracted by css-extract-rspack-plugin
export default {"additionalCheckLogo":"additional-check-logo--rJvbS0azwcHbva5Z"};